import { selectBuildingUpgradeLevelRequirements } from "../../../../selectors/selectExistingBuildingInfo";
export var checkBuildingUpgradeHasEnoughLevel = function (path) { return function (action, state$) {
    var state = state$.value;
    var playerInfo = state.playerInfo;
    var building = action.building, premium = action.premium;
    var levelRequirement = selectBuildingUpgradeLevelRequirements(state, building, premium);
    if (levelRequirement &&
        levelRequirement.requiredPlayerLevel &&
        levelRequirement.requiredPlayerLevel > playerInfo.level) {
        return path;
    }
    if (levelRequirement &&
        levelRequirement.requiredAdventurerLevel &&
        levelRequirement.requiredAdventurerLevel > (playerInfo.adventurerLevel || 0)) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/checks/checkBuildingUpgradeHasEnoughLevel.ts
// module id = 2072
// module chunks = 3